import { STORAGE } from '../../helpers/device.helper';

type PermissionType = 'notification';

export const setUserRespondedPermissions = () => STORAGE.setItem('user-responded-permissions', 'true');

export const getUserRespondedPermissions = () => STORAGE.getItem('user-responded-permissions') === 'true';

export const setUserPermission = (permission: PermissionType) =>
  STORAGE.setItem(`user-${permission}-permission`, 'true');

export const getUserPermission = (permission: PermissionType) =>
  STORAGE.getItem(`user-${permission}-permission`) === 'true';
